import services from '@/services'

export const getGuestProfile = () =>
  services.get('Guest/GetProfile')

export const updateGuestProfile = (data) =>
  services.put('Guest/UpdateProfile', data)

export const updateGuestCompanyData = (data) =>
  services.put('Guest/UpdateCompanyData', data)

export const updateGuestNotificationSettings = (data) =>
  services.put('Guest/UpdateNotificationSettings', data)
  // data: { sendSpedilinkNotifications: boolean }
